export enum EPosition {
  FOOTER = 'footer',
  HEADER = 'header',
  HIDE = 'hide',
}
